(() => {
  const cartPattern = /(?:أضف|إضافة|اضافة).*(?:السلة|السله)|add\s+to\s+cart/i;
  const locationPattern = /موقع\s*القطعة|موضع\s*القطعة|part\s+location|location\s+of\s+(?:the\s+)?part/i;
  const selector = 'a, button, [role="button"]';
  const locateButtonSelector = '.sf-camry-locate-button, [data-sf-camry-locate]';
  let frame = 0;

  const labelText = (element) => [
    element.getAttribute('aria-label') || '',
    element.getAttribute('title') || '',
    element.textContent || ''
  ].join(' ').replace(/\s+/g, ' ').trim();

  const addLocationIcon = (element) => {
    if (element.matches(locateButtonSelector) || element.querySelector('.sf-action-location-fix__icon')) return;
    const icon = document.createElement('span');
    icon.className = 'sf-action-location-fix__icon';
    icon.setAttribute('aria-hidden', 'true');
    icon.innerHTML = '<svg viewBox="0 0 24 24"><path d="M12 21s6-5.2 6-11a6 6 0 1 0-12 0c0 5.8 6 11 6 11Z"></path><circle cx="12" cy="10" r="2.2"></circle></svg>';
    element.prepend(icon);
  };

  const enhance = (root = document) => {
    root.querySelectorAll(selector).forEach((element) => {
      const text = labelText(element);
      if (!text) return;
      if (cartPattern.test(text)) element.classList.add('sf-action-label-fix', 'sf-action-cart-fix');
      const isLocateButton = element.matches(locateButtonSelector) ||
        (locationPattern.test(text) && !element.matches('.sf-camry-map-launch'));
      if (isLocateButton) {
        element.classList.add('sf-action-label-fix', 'sf-action-location-fix');
        addLocationIcon(element);
      }
    });
  };

  const schedule = () => {
    if (frame) return;
    frame = requestAnimationFrame(() => {
      frame = 0;
      enhance(document);
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule, { once: true });
  else schedule();

  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', schedule);
})();
